/** 本文件由工具自动生成,请勿手动修改！ **/
// @ts-nocheck
import { useState,  useEffect } from 'react';
import * as R from 'ramda';
import Request, { YWRequestConfig } from '@ywfe/request';
import { getHost, reduceParams, parseParams, querystring } from '@ywfe/utils';


const { basePath = '', loginPath = '' } = getHost("PRO_SETTLE", "446")




export interface API50730Req {
  
  /** 任务id */
  taskId?: number;
  /** 评论内容 */
  content?: string;
};



export interface API50730Res {
  /**   */
  code?: string;
  /**   */
  msg?: string;
  /**   */
  success?: boolean;
  /** data  */
  data?: boolean;
  /**   */
  exceptionMsg?: string;
  
};


// 50730 新增任务评论

export interface IUsePostAPI50730Return {
  /** 新增任务评论: 接口请求状态 */
  isAPI50730Loading: boolean;
  /** 新增任务评论: 接口请求返回数据 */
  dataAPI50730: API50730Res;
  /**  新增任务评论: 接口数据请求方法 */
  fetchAPI50730Data:  (inputs: API50730Req, config?: YWRequestConfig) => Promise<API50730Res>;
  /** 新增任务评论: 接口请求URL */
  requestUrl: string;
}

export const usePostAPI50730 = ():IUsePostAPI50730Return => {
  let isMount = true;
  const [isAPI50730Loading, setIsAPI50730Loading] = useState(false);
  const [dataAPI50730, setDataAPI50730] = useState<API50730Res>({} as API50730Res);
  const requestUrl = `${basePath}/team-work/workTask/comment/add`;

  const fetchAPI50730Data = async (inputs: API50730Req, config?: YWRequestConfig): Promise<API50730Res> => {
  
    
    const params = (reduceParams(inputs as unknown as R.Dictionary<API50730Req>) || {}) as API50730Req;
    
  
    if ( isMount ) {
      setIsAPI50730Loading(true);
    }

    try {
      
      
      
      const res: any = await Request.post<API50730Res>(`${basePath}/team-work/workTask/comment/add`, params, {
        loginHost: loginPath,
        ...config
      });
      
      
      if (isMount) {
        setDataAPI50730(res || {} as API50730Res);
        setIsAPI50730Loading(false);
      }
      return res;
    } catch (error) {
      console.error('[ERROR] API Request Error: ', error);
      if ( isMount ) {
        setIsAPI50730Loading(false);
      }
      return false as unknown as API50730Res;
    }
  }

  useEffect(() => {
    return () => {
      isMount = false;
    };
  }, []);

  return {
    isAPI50730Loading,
    dataAPI50730,
    fetchAPI50730Data,
    requestUrl,
  }
}

